import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaFacebookF,
  FaInstagram,
  FaGoogle,
} from 'react-icons/fa';
import services from '../../utils/services';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Booking', path: '/booking' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Blog', path: '/blog' },
    { name: 'Feedback', path: '/feedback' },
    { name: 'Gallery', path: '/gallery' },
  ];

  const socialLinks = [
    { icon: FaFacebookF, url: '#', label: 'Facebook' },
    { icon: FaInstagram, url: '#', label: 'Instagram' },
    {
      icon: FaGoogle,
      url: 'https://g.page/r/CQAwFW3XDNHXEBM/review',
      label: 'Google Review',
    },
  ];

  return (
    <footer className="bg-primary-500 text-white">
      {/* Main Footer */}
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="mb-6 inline-flex items-center rounded-xl bg-white px-3 py-2 shadow-md">
              <img
                src="/logo/theskilledgroup-logo.svg"
                alt="The Skilled Group logo"
                className="h-14 w-auto"
                loading="lazy"
              />
            </div>
            <p className="text-primary-100 mb-6 leading-relaxed">
              Professional pest control and cleaning services in Brisbane, Australia. We deliver exceptional results with eco-friendly products and experienced staff.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  aria-label={social.label}
                  className="w-10 h-10 bg-primary-400 rounded-lg flex items-center justify-center
                             hover:bg-accent-500 transition-colors duration-200"
                >
                  <social.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-primary-100 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-primary-100 hover:text-accent-400 transition-colors duration-200"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:0466708090"
                  className="flex items-start gap-3 text-primary-100 hover:text-accent-400 transition-colors"
                >
                  <FaPhone className="mt-1 flex-shrink-0" />
                  <span>0466708090</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@theskilledgroup.com"
                  className="flex items-start gap-3 text-primary-100 hover:text-accent-400 transition-colors"
                >
                  <FaEnvelope className="mt-1 flex-shrink-0" />
                  <span>info@theskilledgroup.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-primary-100">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <span>Brisbane, QLD, Australia</span>
              </li>
              <li className="flex items-start gap-3 text-primary-100">
                <FaClock className="mt-1 flex-shrink-0" />
                <span>Open 24/7</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-400">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-primary-200 text-sm text-center md:text-left">
              &copy; {currentYear} The Skilled Group. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {legalLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-primary-200 text-sm hover:text-accent-400 transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
          {/* <p className="mt-4 text-center text-primary-200 text-xs sm:text-sm">
            Website designed and developed by{' '}
            <a
              href="https://github.com/bipan101"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-accent-400 hover:text-accent-300 transition-colors"
            >
              Bipan Neupane
            </a>
            .
          </p> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;